import { render } from "./HederStyleTwo.vue?vue&type=template&id=8cf5b986"
import script from "./HederStyleTwo.vue?vue&type=script&lang=js"
export * from "./HederStyleTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__